import { render, staticRenderFns } from "./RequestCompare.vue?vue&type=template&id=43f70a9b&"
import script from "./RequestCompare.vue?vue&type=script&lang=js&"
export * from "./RequestCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports